var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedeem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2001 0.923096C2.21187 0.923096 0.600098 2.47288 0.600098 4.38463V11.3077C0.600098 13.2195 2.21187 14.7692 4.2001 14.7692L4.2001 4.38463H22.2001C22.2001 2.47288 20.5883 0.923096 18.6001 0.923096H4.2001Z",
    fill: "#AABCCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8001 11.3077C7.8001 9.39596 9.41187 7.84617 11.4001 7.84617H25.8001C27.7883 7.84617 29.4001 9.39596 29.4001 11.3077V18.2308C29.4001 20.1425 27.7883 21.6923 25.8001 21.6923H11.4001C9.41187 21.6923 7.8001 20.1425 7.8001 18.2308V11.3077ZM18.6001 18.2308C20.5883 18.2308 22.2001 16.681 22.2001 14.7692C22.2001 12.8575 20.5883 11.3077 18.6001 11.3077C16.6119 11.3077 15.0001 12.8575 15.0001 14.7692C15.0001 16.681 16.6119 18.2308 18.6001 18.2308Z",
    fill: "#AABCCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeem);
export default __webpack_public_path__ + "static/media/redeem.c08f0cdb.svg";
export { ForwardRef as ReactComponent };